const region = process.env.REACT_APP_REGION;
const userPoolId = process.env.REACT_APP_USER_POOL_ID;
const clientId = process.env.REACT_APP_CLIENT_ID;
const identityPoolId = process.env.REACT_APP_IDENTITY_POOL_ID;
const redirectURL = process.env.REACT_APP_REDIRECT_URL;
const apiStage = process.env.REACT_APP_API_STAGE;
const authDomain = process.env.REACT_APP_AUTH_DOMAIN;
const identityProvider = process.env.REACT_APP_IDP;
const signInRedirect = `${redirectURL}/login`;
//const signOutRedirect = `${redirectURL}/logout`;
const signOutRedirect = 'https://auth.deltacollege.edu/idp/profile/Logout';

const oauth = {
  domain : authDomain,
  scope : ['email', 'profile', 'openid','aws.cognito.signin.user.admin'],
  redirectSignIn : signInRedirect,
  redirectSignOut : signOutRedirect,
  responseType: 'code',
  options: {
    AdvancedSecurityDataCollectionFlag: false,
    IdentityProvider: identityProvider
  }
};

const apiGateway = {
  students: {
    URL: `https://${process.env.REACT_APP_STUDENTS_API}.execute-api.${region}.amazonaws.com/${apiStage}`,
  },
  applications: {
    URL: `https://${process.env.REACT_APP_APPLICATIONS_API}.execute-api.${region}.amazonaws.com/${apiStage}`,
  },
  periods: {
    URL: `https://${process.env.REACT_APP_PERIODS_API}.execute-api.${region}.amazonaws.com/${apiStage}`,
  },
  studentService: {
    URL: `https://${process.env.REACT_APP_STUDENT_SERVICE_API}.execute-api.${region}.amazonaws.com/${apiStage}`,
  }
};

const Amplify = {
  API: {
    endpoints: [
      {
        name: "periods",
        endpoint: apiGateway.periods.URL + '/',
        region
      },
      {
        name: "studentService",
        endpoint: apiGateway.studentService.URL + '/',
        region
      },
      {
        name: "students",
        endpoint: apiGateway.students.URL + '/',
        region
      }
    ]
  },
  Auth: {
    identityPoolId: identityPoolId,
    region: region,
    userPoolId: ''
  }
};

export default {
  Amplify
}
